var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragHandle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_13873_26079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98438 6.83594C9.52372 6.83594 9.96094 6.39872 9.96094 5.85938C9.96094 5.32003 9.52372 4.88281 8.98438 4.88281C8.44503 4.88281 8.00781 5.32003 8.00781 5.85938C8.00781 6.39872 8.44503 6.83594 8.98438 6.83594Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 6.83594C16.555 6.83594 16.9922 6.39872 16.9922 5.85938C16.9922 5.32003 16.555 4.88281 16.0156 4.88281C15.4763 4.88281 15.0391 5.32003 15.0391 5.85938C15.0391 6.39872 15.4763 6.83594 16.0156 6.83594Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98438 13.4766C9.52372 13.4766 9.96094 13.0393 9.96094 12.5C9.96094 11.9607 9.52372 11.5234 8.98438 11.5234C8.44503 11.5234 8.00781 11.9607 8.00781 12.5C8.00781 13.0393 8.44503 13.4766 8.98438 13.4766Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 13.4766C16.555 13.4766 16.9922 13.0393 16.9922 12.5C16.9922 11.9607 16.555 11.5234 16.0156 11.5234C15.4763 11.5234 15.0391 11.9607 15.0391 12.5C15.0391 13.0393 15.4763 13.4766 16.0156 13.4766Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98438 20.1172C9.52372 20.1172 9.96094 19.68 9.96094 19.1406C9.96094 18.6013 9.52372 18.1641 8.98438 18.1641C8.44503 18.1641 8.00781 18.6013 8.00781 19.1406C8.00781 19.68 8.44503 20.1172 8.98438 20.1172Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 20.1172C16.555 20.1172 16.9922 19.68 16.9922 19.1406C16.9922 18.6013 16.555 18.1641 16.0156 18.1641C15.4763 18.1641 15.0391 18.6013 15.0391 19.1406C15.0391 19.68 15.4763 20.1172 16.0156 20.1172Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13873_26079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandle);
export default __webpack_public_path__ + "static/media/drag-handle.3db21277.svg";
export { ForwardRef as ReactComponent };